import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
// import { SESSION_STORAGE, StorageService } from 'angular-webstorage-service';
import { environment } from "../../../environments/environment";
import { AuthService } from '../../services/auth.service';
import { AppConstants, MessagesConstants } from '../../shared/constants/app.constants';
import { AppComponent } from '../../app.component';
import { UserService } from '../../services/user.service';
import { UserApplicationViewModel } from '../../models/application.user.model';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { FormService } from 'src/app/shared/services/validation.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  today = new Date();
  username: string;
  password: string;
  returnUrl: string;
  campoVacio: boolean = false;
  usuarioFormError: boolean = false;
  contrasenaFormErrors: boolean = false;
  popupExito: boolean = false;
  showModalReload: boolean = false;
  @Output() navigateToEvent = new EventEmitter<string>();
  @Output() menuToEvent = new EventEmitter<any>();

  credentialsIncorrect : boolean = false;
  permissionsApp: boolean = false;

  //validateCaptcha: boolean = true; // LOCAL QA  
  validateCaptcha: boolean = false; //PROD

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appComponent: AppComponent,
    private authService: AuthService,
    private userService: UserService,
    private giftCardService: GifcardVirtualService,
    private formService: FormService
    // @Inject(SESSION_STORAGE) private storage: StorageService,
  ) {

    var tokenSessions = localStorage.getItem("access_token");
    if (tokenSessions != null && tokenSessions != undefined && tokenSessions != '') {
      localStorage.removeItem("access_token");
      this.appComponent.loading = false;
      this.popupExito = true;
      //this.alertService.showMessage(AppConstants.TituloModal.TITULO_LOGIN, "", MessageSeverity.warn);
      //this.popupExito = true;
    }

  }

  LoginForm: FormGroup;
  usuarioForm: FormControl;
  contrasenaForm: FormControl;

  createFormControls() {
    this.usuarioForm = new FormControl(null, [Validators.required]);
    this.contrasenaForm = new FormControl(null, [Validators.required]);
  }

  createForm() {
    this.LoginForm = new FormGroup({
      usuarioForm: this.usuarioForm,
      contrasenaForm: this.contrasenaForm
    });
  }

  public formErrors = {
    usuarioForm: '',
    contrasenaForm: '',
  };


  ngOnInit() {
    //debugger;
    this.createFormControls();
    this.createForm();
  }

  LoginOnEnter(event) {
    this.login();
  }

  showResponse(event){
    let captchaResponse = event.response;
    this.giftCardService.validateCaptcha(captchaResponse).subscribe(
      (response => {
        if (response.success){
          this.validateCaptcha = true;
        }
        else{
          this.validateCaptcha = false;
        }
      }),
      (error => {

      })
    );
  }

  login() {
    this.credentialsIncorrect = false;
    this.permissionsApp = false;

    this.formService.markFormGroupTouched(this.LoginForm);

    if(this.LoginForm.valid){
      this.popupExito = true;
      this.authService.GetAuthTokenAsync(this.usuarioForm.value,this.contrasenaForm.value).subscribe(
        (response: any) => {
          localStorage.setItem('access_token',response.access_token);
          localStorage.setItem('expires_in',response.expires_in);
          this.authService.setCurrentUser(this.usuarioForm.value);          

          //debugger;
          //Autorizador
         // "aplicationcode": "4", --cambiar en produccion
         // "aplicationcode": "20020", --cambiar en QA
          let filter = {
            "username": this.usuarioForm.value,
            "aplicationcode": "4",
            "countrycode": "PE",
            "locationcode": AppConstants.AplicacionParametros.sucursalId,
            "profilecode" : AppConstants.AplicacionParametros.profileCode
          }
          this.userService.GetUserLoginMSA(filter).subscribe(
            (response: UserApplicationViewModel) => {
              localStorage.setItem('userApplicationData', JSON.stringify(response));
              this.navigateTo('home');
            },
            (error) => {
              this.popupExito = false;
              this.permissionsApp = true;
              localStorage.setItem('userApplicationData', '');
            }
          )
          // this.popupExito = false;
          //this.navigateTo('home');
          // this.rows = response;
          // this.loadingIndicator = false;
        },
        (error) => {
          this.credentialsIncorrect = true;
          this.popupExito = false;
          // this.alertService.showMessage(AppConstants.TituloModal.TITULO_APLICACION_LISTA, AppConstants.error.ERRRO_HTTP, MessageSeverity.error);
          // this.loadingIndicator = false;
        }
      )
    }else {
      this.formErrors = this.formService.validateForm(this.LoginForm, this.formErrors, MessagesConstants.Login, false);
    }

    // this.navigateTo('home');
  }

  navigateTo(route: string) {
    this.navigateToEvent.next(route);
  }

}
